import dayjs = require("dayjs");

import { calculateInstallmentDates, calculateInstallmentsCashFlow, convertToInterestFraction } from "../commons";
import { PaymentInterval } from "../simulator/simulator";


export interface ICetInfo {
    monthlyRate: number;
    annualyRate: number;
}

export interface ICetCalculateParams {
    amount: number;
    tenure: number;
    interestRate: number;
    loanDate: Date;
    dueDate: Date;
    pmt: number;
    paymentInterval: PaymentInterval;
    downPayments?: number;
}

export const calculateCet = (request: ICetCalculateParams): ICetInfo => {
    const { amount, tenure, interestRate, loanDate, dueDate, pmt, paymentInterval, downPayments } = request;

    const interestFraction = convertToInterestFraction(interestRate, paymentInterval);
    const installmentsCashFlow = calculateInstallmentsCashFlow(
        dueDate,
        tenure,
        paymentInterval,
        pmt,
        interestFraction * amount,
        downPayments
    );

    installmentsCashFlow.unshift([-amount, loanDate]);

    const grossAnnualy = xirr(installmentsCashFlow);
    const monthlyRate = Math.pow(1 + grossAnnualy, 1 / 12) - 1;
    const annualyRate = Math.pow(1 + monthlyRate, 12) - 1;

    const cetInfo: ICetInfo = {
        monthlyRate, annualyRate
    };

    return cetInfo;
}

const xirr = (cashFlowDatesAndAmounts: Array<Array<number | Date>>) => {
    let anos = cashFlowDatesAndAmounts.map((flow: Array<number | Date>) => {
        const first = dayjs(flow[1]).startOf('day');
        const second = dayjs(cashFlowDatesAndAmounts[0][1]).startOf('day');
        const days = (first).diff(second, 'day');

        return days / 365;
    });

    let residuo = 1;
    let salto = 0.05;
    let palpite = 0.05;
    let epsilon = 0.0001;
    let limit = 10000;

    while ((Math.abs(residuo) > epsilon) && (limit > 0)) {
        limit -= 1;
        residuo = 0.0;

        cashFlowDatesAndAmounts.forEach((flow: Array<number | Date>, index: number) => {
            const numerador = flow[0] as number;
            const denominador = Math.pow(palpite, anos[index]);
            const adicionar = numerador / denominador;

            residuo += adicionar;
        });

        if (Math.abs(residuo) > epsilon) {
            if (residuo > 0) {
                palpite += salto
            } else {
                palpite -= salto
                salto /= 2.0
            }
        }
    }

    return palpite - 1;
}